import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  AddUsersToCohortDto,
  AddUsersToCohortResponseDto,
} from '../../../models/user-cohort/dto/user-cohort.dto';
import { GET_COHORT_QUERY_KEY } from './useGetCohort';
import { GET_COHORT_MEMBERS_QUERY_KEY } from './useGetCohortMembers';

export function useAddUsersToCohort(cohortId: string) {
  const queryClient = useQueryClient();
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async (dto: AddUsersToCohortDto) => {
      const response = await apiClient.fetchApi<
        AddUsersToCohortResponseDto,
        AddUsersToCohortDto
      >({
        method: 'POST',
        endpoint: `cohorts/${cohortId}/members`,
        body: dto,
      });
      return response;
    },
    onSuccess: () => {
      // Invalidate cohort to refresh member count
      queryClient.invalidateQueries({
        queryKey: GET_COHORT_QUERY_KEY(cohortId),
      });
      // Invalidate members list
      queryClient.invalidateQueries({
        queryKey: GET_COHORT_MEMBERS_QUERY_KEY(cohortId, undefined, undefined),
      });
    },
  });
}
